<template>
  <button
    type="button"
    class="context-burger"
    @click="showContextMenu(item)"
    :class="{ active: isActive }">

    <i class="fal fa-bars"></i>
  </button>
</template>

<script>
import ContextMenuModal from '@/components/nav/ContextMenuModal'

export default {
  name: 'context-menu',
  data () {
    return {
      isActive: false
    }
  },
  components: {
    ContextMenuModal
  },
  props: {
    item: Object
  },
  computed: {
  },
  methods: {
    showContextMenu (item) {
      this.isActive = true
      this.$panel(ContextMenuModal, { item }, '300px')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nav/ContextMenu.vue